import {
  FilteredTemplateData,
  FilterTemplateDataByLanguageParams,
  LANGUAGE_FILTER_ALL,
} from '../config';

import { matchesLanguageFilter } from './matchesLanguageFilter';

export const filterTemplateDataByLanguage = ({
  language,
  schemas,
  templates,
}: FilterTemplateDataByLanguageParams): FilteredTemplateData => {
  if (language === LANGUAGE_FILTER_ALL) {
    return { schemas, templates };
  }

  return {
    schemas: schemas.filter((schema) =>
      matchesLanguageFilter(language, schema.language),
    ),
    templates: templates.filter((template) =>
      matchesLanguageFilter(language, template.language),
    ),
  };
};
